import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from 'syf-component-library/ui/spacing';
import useTranslation from '../../../hooks/use-translation';
import NoPromotionsIllustration from '../../common/illustrations/no-transaction';
import useTriggerAnalyticsEvent from '../../../hooks/use-trigger-analytics-event';
import { StyledNoPromotionsContainer, StyledNoPromotionsMessage } from './subcomponents';
const NoPromotions = () => {
    const t = useTranslation();
    useTriggerAnalyticsEvent('promoCenterTab.noPromos');
    return (_jsxs(StyledNoPromotionsContainer, { children: [_jsx(NoPromotionsIllustration, {}), _jsx(Stack, {}), _jsx(StyledNoPromotionsMessage, { size: "large", weight: "bold", children: t('promotions.noPromotionsMessage') })] }));
};
export default NoPromotions;
//# sourceMappingURL=index.js.map